import { render, staticRenderFns } from "./EducationModule.vue?vue&type=template&id=3d4ffd6e&"
import script from "./EducationModule.vue?vue&type=script&lang=ts&"
export * from "./EducationModule.vue?vue&type=script&lang=ts&"
import style0 from "./EducationModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports